module.exports = __webpack_public_path__ + "static/media/ladestasjon.d2e59e6d.svg";